import { useEffect } from 'react';

type TProps = {
  id: string;
  isOpen: boolean;
};

export const useScrollIntoView = ({ id, isOpen }: TProps): void => {
  useEffect(() => {
    if (isOpen) {
      const button = document.getElementById(id);
      if (!button) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          observer.unobserve(button);
        },
        {
          root: null,
          threshold: 0.1,
        },
      );

      observer.observe(button);
    }
  }, [id, isOpen]);
};
